module.exports = __webpack_public_path__ + "static/media/3.977ac192.JPG";